// extracted by mini-css-extract-plugin
export default {"btnMore":"BtnMore_btnMore__s+0uY"};